module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_yellow.3c7a60e5.svg";